module.exports = __webpack_public_path__ + "static/business-services-hero.9722792e.webp";